import { useCallback, useEffect, useState } from 'react';

interface Props {
  quantity: number;
  seeAsUnit: boolean;
  currentMeasure: string;
}

export function useFormatQuantity({ quantity, currentMeasure, seeAsUnit }: Props) {
  const format = useCallback((quantity: number, currentMeasure: string, seeAsUnit: boolean) => {
    const pattern = /([\d]+)\.([\d]+)/;
    const isQuantityRight = new RegExp(pattern);

    if (!seeAsUnit && currentMeasure === 'kg' && !isQuantityRight.test(quantity.toString())) {
      const hasComma = quantity.toString().includes(',') || quantity.toString().includes('.');

      // eslint-disable-next-line no-param-reassign
      quantity = parseFloat(quantity.toString().replace(/[^\d]/g, ''));

      if (quantity > 50 || hasComma) {
        // eslint-disable-next-line no-param-reassign
        quantity *= 10 ** -3;
      }
    }

    return currentMeasure === 'kg' && !seeAsUnit
      ? quantity.toFixed(3).replace('.', ',')
      : quantity.toString();
  }, []);

  const [quantityFormated, setQuantityFormated] = useState<string>(() =>
    format(quantity, currentMeasure, seeAsUnit),
  );

  useEffect(
    () => setQuantityFormated(format(quantity, currentMeasure, seeAsUnit)),
    [quantity, currentMeasure, seeAsUnit, format],
  );

  return quantityFormated;
}
